import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { TimKiemNhanVienRequest } from '@app/models/nhanvien/NhanVien';
import { Button, Col, Input, Row, Space, Table } from 'antd';
import Column from 'antd/es/table/Column';
import { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { ContentHeader } from "../../components";
import { idQuyDauTu } from '../../constants';
import { Links } from '../../helpers/Links';
import { menuHelper } from '../../helpers/account';
import { NguoiDungPagingResponse, NguoiDungResponse } from '../../models/nguoidung/NguoiDung';
import ContainerDepartment from '../../modules/department/ContainerDepartment';
import { timKiemDSNhanVien } from '../../services/nhanvien';
import DanhSachTaiKhoanBox from './DanhSachTaiKhoanBox';

const DanhSachNguoiDung = () => {
    const [tuKhoa, setTuKhoa] = useState<string>("");
    const [isLoadingTable, setIsLoadingTable] = useState(true);
    const [idDonVi, setIdDonVi] = useState<number>(idQuyDauTu);
    const menu: any = menuHelper.checkMultiPermission([Links.HopDong.ChiTiet]);
    const [expandedRows, setExpandedRows] = useState<Array<NguoiDungResponse>>([]);


    const [danhsach, setDanhSach] = useState<NguoiDungPagingResponse>({
        "data": [],
        "recordsTotal": 0,
        "maxPage": 0,
        "pageCurrent": 0,
        "pageListShow": [0]
    });

    const timkiem = async (idDonVi: number, tuKhoa: string, start: number, length: number, page: number) => {
        try {
            setIsLoadingTable(true);
            var rq = new TimKiemNhanVienRequest;
            rq.idDonVi = idDonVi;
            rq.tuKhoa = tuKhoa;
            const temp = await timKiemDSNhanVien(rq, start, length);
            setDanhSach({
                "data": (temp?.data || []).map((item: any) => { item.key = item.id; return item }),
                "recordsTotal": temp?.recordsTotal || 0,
                "maxPage": 0,
                "pageCurrent": page,
                "pageListShow": []
            });
        }
        catch (error: any) {
        };

        setIsLoadingTable(false);
    }

    const onChangeDepartment = (e: any) => {
        if (e) {
            setIdDonVi(e.id);
            timkiem(e.id, tuKhoa, 0, 0, 0);
        } else {
            setIdDonVi(0);
            setDanhSach({
                "data": [],
                "recordsTotal": 0,
                "maxPage": 0,
                "pageCurrent": 0,
                "pageListShow": [0]
            });
        }
    };

    const containerDepartmentProps = {
        showHeader: false,
        onChange: onChangeDepartment,
        treeProps: {
            defaultExpandedKeys: [idQuyDauTu],
            defaultSelectedKeys: [idQuyDauTu]
        }
    };

    useEffect(() => {
        setDanhSach({
            "data": [],
            "recordsTotal": 0,
            "maxPage": 0,
            "pageCurrent": 0,
            "pageListShow": [0]
        });
        timkiem(idDonVi, tuKhoa, 0, 0, 0);
    }, []);

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            timkiem(idDonVi, tuKhoa, 0, 0, 0)
        }
    };
    return (<section>
        <ContentHeader title="Quản lý tài khoản" />
        <Row className="form-group"  gutter={8}>
            <Col span={8}>
                <Input prefix={<SearchOutlined rev="" />} placeholder="Nhập tên, mã nhân viên, email, số điện thoại" onChange={(e) => setTuKhoa(e.target.value)}
                    onKeyPress={handleKeyPress} />
            </Col>
            <Col span={8}>
                <Space>
                    <Button type="primary" icon={<SearchOutlined rev="" />} onClick={() => timkiem(idDonVi, tuKhoa, 0, 0, 0)}>
                        Tìm kiếm
                    </Button>{/*
                    <Button className="hrm-btn hrm-btn-success" icon={<DownloadOutlined rev="" />}>
                    Xuất excel
                    </Button>*/}
                </Space>
            </Col>
            <Col span={8}>
                {
                    menu[Links.NhanVien.ChiTiet] &&
                    <Link className="hrm-btn float-right btn-warning" to={Links.NhanVien.ChiTiet}><PlusOutlined rev="" />Thêm mới</Link>
                }
            </Col>
        </Row>
        <Row gutter={8}>
            <Col sm={6}>
                <ContainerDepartment {...containerDepartmentProps} />
            </Col>
            <Col sm={18}>
                <div className="card card-primary">
                    <Row>
                        <Col span="24">
                            <Table dataSource={danhsach?.data} loading={isLoadingTable}
                                locale={{ emptyText: "Không có dữ liệu" }}
                                expandable={{
                                    expandedRowRender: (record) => <DanhSachTaiKhoanBox idNhanVien={record.id} />,
                                    onExpand: (expand, record) => {
                                        if (expand) {
                                            expandedRows?.push(record);
                                        } else {
                                            const index = expandedRows?.findIndex((v) => v.id === record.id) || -1;
                                            if (index > -1) {
                                                expandedRows?.splice(index, 1);
                                            }
                                        }

                                        setExpandedRows(expandedRows);
                                    }
                                }}
                            >
                                <Column title="Tên nhân viên" dataIndex="hoTen" key="hoTen" />
                                <Column title="Email" dataIndex="email" key="email" />
                                <Column title="Số điện thoại" dataIndex="dienThoai" key="dienThoai" />
                                <Column title="Chức vụ" dataIndex="tenChucVu" key="tenChucVu" />
                                <Column title="Phòng ban" dataIndex="tenDonVi" key="tenDonVi" />
                            </Table>
                        </Col>
                    </Row>
                </div>
            </Col>
        </Row>
    </section>
    );
};

export default DanhSachNguoiDung;
